import React, { useEffect }  from 'react';
import { useLocation } from 'react-router-dom';
import '../../style/agentsList.css'
import '../../style/premiumList.css'
import FormGroupSelectInput from "../formGroupSelectInput";
import SolicitorGroupHOC from '../../containers/SolicitorGroups/solicitorGroupHOC'
import Button from "../button";
import FormResponseMessage from "../formResponseMessage";
import PremiumSettingsWizardHOC from '../../containers/PremiumSettings/premiumSettingsWizardHOC'
import PremiumSettingsCombinationTable from "./premiumSettingsCombinationTable";
import CenteredDots from "../General/centeredDots";
import CustomCheckbox from "../General/customCheckbox";
import CustomModal from "../General/customModal";
import PremiumSettingsCopyForm from "./premiumSettingsCopyForm";
import { CANADA_COUNTRY, COUNTRY, LEGAL_ADVICE_TEXT, PREMIUM_SETTINGS_TABS, PERCENTAGE_PREMIUMS_AVAILABLE } from '../../helpers/variables';
import {HorizontalRule, NavigationBar, NavigationContent} from 'arag-ui-lib'
import StagedPremiumSettingsCombinationTable from './stagedPremiumSettingsCombinationTable';
import StagedStep4 from './WizardSteps/stagedStep4';
import {clearSuccessMsg} from "../../helpers/utilMessage";
import { PS_TYPE_CUSTOM, PS_TYPE_DEFAULT, PS_TYPE_PERCENTAGE, PS_TYPE_STAGED } from '../../helpers/constants';

const PremiumSettings = (props) => {

	const {
		isCopyModalOpen,
		openCopyModal,
		closeCopyModal,
		groupCaseAndSubTypes,
		getSolicitorGroupCaseTypes,
		requestGetSolicitorGroupWorkSources,
		createNewHandle,
		isCopyStagedModalOpen,
		toggleStagedCopyModal
	} = props;

	let groupOptions = [{key: '', value: 'None'}, ...props.premiumSettings.solicitorGroups.map((option) => {
		return {value: option.name, key: option.id}
	})];
	let worksourcesOptions = [{key: '', value: 'None'}, ...props.premiumSettings.worksources.map((option) => {
		return {value: option.name, key: option.id}
	})];
	if (props.fetchingCaseTypes) {
		return (
			<div className="col-sm-12">
				<CenteredDots/>
			</div>
		)
	}

	const location = useLocation();
	const successMsg = location.state && location.state.successMsg;	

	//clear the message at page refresh.
	useEffect(() => {
		window.addEventListener('beforeunload', clearSuccessMsg(location));
		return () => {
			window.removeEventListener('beforeunload', clearSuccessMsg(location));
		};
	}, []);

	return (
		<div className="row">
			<h2 className="agents-list-title col-sm-12">{'Premium Settings'}</h2>
			<div className="col-sm-12">
				{isCopyModalOpen && (
					<CustomModal
						isOpen={isCopyModalOpen}
						content={<PremiumSettingsCopyForm
							onCancel={closeCopyModal}
							groupCaseAndSubTypes={groupCaseAndSubTypes}
							caseTypes={props.caseTypesRecords}
							subCaseTypes={props.subCaseTypesRecords}
							groupOptions={groupOptions}
							workSourcesOptions={worksourcesOptions}
							premiumSettingsId={props.premiumSettings.editingPremiumSettingId}
							getSolicitorGroupCaseTypes={getSolicitorGroupCaseTypes}
							requestGetSolicitorGroupWorkSources={requestGetSolicitorGroupWorkSources}
							changeNewPremiumStoreSettings={props.changeNewPremiumStoreSettings}
							stagedId={''}
							premiumSettingType={props.premiumSettings.psType}
						/>}
						handleClose={closeCopyModal}
					/>
				)}
				{isCopyStagedModalOpen && (
					<CustomModal
						isOpen={isCopyStagedModalOpen}
						content={<PremiumSettingsCopyForm
							onCancel={toggleStagedCopyModal}
							groupCaseAndSubTypes={groupCaseAndSubTypes}
							caseTypes={props.caseTypesRecords}
							subCaseTypes={props.subCaseTypesRecords}
							groupOptions={groupOptions}
							workSourcesOptions={worksourcesOptions}
							premiumSettingsId={props.premiumSettings.editingPremiumSettingId}
							getSolicitorGroupCaseTypes={getSolicitorGroupCaseTypes}
							requestGetSolicitorGroupWorkSources={requestGetSolicitorGroupWorkSources}
							changeNewPremiumStoreSettings={props.changeNewPremiumStoreSettings}
							stagedId={props.stagedPremiums.stagedPremiumSetting?.id != undefined ? props.stagedPremiums.stagedPremiumSetting.id : '' }
						/>}
						handleClose={toggleStagedCopyModal}
					/>
				)}
				{
					props.premiumSettings.openDeleteModal ?
						<div className="appFormRefSettings-modal">
							<div className="solicitorGroup-deleteModal-content">
								<div className="appFormRefSettings-close-button"
									onClick={() => {
										props.changeNewPremiumStoreSettings('deleteResponseMsg', '');
										props.changeNewPremiumStoreSettings('premiumSettingSelectedToDelete', '');
										props.changeNewPremiumStoreSettings('openDeleteModal', false)
									}}></div>
								<div className="col-xs-12">Are you sure you want to delete the selected premium setting?
								</div>
								{
									props.premiumSettings.deleting ?
										<div className="col-sm-12">
											<CenteredDots/>
										</div>
										:
										null
								}
								<div className="col-xs-12">
									<Button clickHandler={() => {
										props.changeNewPremiumStoreSettings('deleteResponseMsg', '');
										props.handleDeletePremiumSetting(props.premiumSettings.premiumSettingSelectedToDelete)
									}} wrapper="btn-wrapper-forForms" btnType="button"
										btnStyle={'btn btn-primary btn-xs sharp yellow'}
											label="Yes"/>
									<Button clickHandler={() => {
										props.changeNewPremiumStoreSettings('deleteResponseMsg', '');
										props.changeNewPremiumStoreSettings('premiumSettingSelectedToDelete', '');
										props.changeNewPremiumStoreSettings('openDeleteModal', false)
									}} wrapper="btn-wrapper-forForms" btnType="button"
										btnStyle={'btn btn-primary btn-xs sharp white'}
										label="No"/>
								</div>
								{
									props.premiumSettings.deleteResponseMsg !== '' ?
										<FormResponseMessage
											LeftWrapper=""
											CenterWrapper="col-xs-12"
											MessageStyle="formResponseMessage-reject"
											Message={props.premiumSettings.deleteResponseMsg}
										/>
										:
										null
								}
							</div>
						</div>
						:
						null
				}
				<div className="form-horizontal">
				{successMsg && (
						<FormResponseMessage
							LeftWrapper=""
							CenterWrapper="col-sm-12"
							MessageStyle="formResponseMessage-success"
							Message={successMsg}
						/>)}
				</div>
				
				{
					props.premiumSettings.openModal ?
						<div className="appFormRefSettings-modal">
							<div className="appFormRefSettings-modal-content">
								<div className="appFormRefSettings-close-button"
									onClick={() => props.changeNewPremiumStoreSettings('openModal', false)}></div>
								<SolicitorGroupHOC storeIsValid={true}/>
							</div>
						</div>
						:
						null
				}
				<div>
					<NavigationBar onNavItemSelect={(key) => props.changepsType(key)} activeItemKey={props.premiumSettings.psType} navItems={PREMIUM_SETTINGS_TABS} />

				</div>

				<div className="form-horizontal" >
							{props.premiumSettings.psType === PS_TYPE_CUSTOM ||props.premiumSettings.psType === PS_TYPE_STAGED || (PERCENTAGE_PREMIUMS_AVAILABLE && props.premiumSettings.psType === PS_TYPE_PERCENTAGE)   ?
								<div style={{paddingTop:30}}>
							<Button clickHandler={() => props.openModal(true)} wrapper="btn-wrapper"
								btnType="button"
								btnStyle={'btn btn-primary btn-xs sharp white'}
								label={`Create New ${LEGAL_ADVICE_TEXT} Group`} />

							<HorizontalRule />

							<FormGroupSelectInput
								Label={`${LEGAL_ADVICE_TEXT} Group`} LeftWrapper="col-sm-2"
								Value={props.premiumSettings.selectedSolicitorGroup}
								Name="selectedSolicitorGroup"
								HandleInputChange={(evt) => props.handleSolGroupsChange(evt.target.name, evt.target.value)}
								Options={groupOptions}
								CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
								RightWrapper=""
								Required={true}
								SelectStyle={'form-control formGroupSelectInput-select'}
							/>
							{
								props.premiumSettings.selectedSolicitorGroup !== '' ?
									<FormGroupSelectInput
										Label="Work source"
										LeftWrapper="col-sm-2"
										Name="selectedWorksource"
										Value={props.premiumSettings.selectedWorksource}
										Options={worksourcesOptions}
												HandleInputChange={evt => { props.changeWorksource(evt); props.viewEditForm(evt.target.name, evt.target.value); 
											props.handleAllPremiumChange('showAllPremiumSettingsForCombination', false);
													props.handleAllStagedPremiumChange('getAllStagedPremiumsForCombination',false);
										}}
										CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
										RightWrapper=""
										SelectStyle={'form-control formGroupSelectInput-select'}

									/>
									:
									null
							}
						</div>
						: <HorizontalRule />}
					{
						((props.premiumSettings.psType === PS_TYPE_CUSTOM || props.premiumSettings.psType === PS_TYPE_STAGED || (PERCENTAGE_PREMIUMS_AVAILABLE && props.premiumSettings.psType === PS_TYPE_PERCENTAGE)) &&
								props.premiumSettings.selectedSolicitorGroup !== '' )
							|| props.premiumSettings.psType === PS_TYPE_DEFAULT ?
							<FormGroupSelectInput
								Label="Case Type" LeftWrapper="col-sm-2"
								Value={props.premiumSettings.selectedCaseType}
								Name="selectedCaseType"
								HandleInputChange={(evt) => { props.changeNewPremiumStoreSettings(evt.target.name, evt.target.value); props.viewEditForm(evt.target.name, evt.target.value); props.changeNewPremiumStoreSettings('selectedSubCaseType', ''); }}
								Options={props.caseTypes}
								CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
								RightWrapper=""
								Required={true}
								SelectStyle={'form-control formGroupSelectInput-select'}
							/>
							:
							null
					}
					<HorizontalRule />


				</div>

				{
					props.subCaseTypes.length > 1 ?
						<div className="premiumList-subCasesTabs-wrapper">
							<NavigationBar onNavItemSelect={(subCase) => {
								props.changeNewPremiumStoreSettings('selectedSubCaseType', subCase.toString());
								props.viewEditForm('selectedSubCaseType', subCase.toString());
							}
							}
								activeItemKey={props.premiumSettings.selectedSubCaseType === '0' ||
									props.premiumSettings.selectedSubCaseType === '' ? '0' : props.premiumSettings.selectedSubCaseType}
								navItems={
									props.subCaseTypes.map((subCase, index) => {
										return { key: index == 0 ? '0' : `${subCase.key}`, label: (subCase.value ? subCase.value : 'Default') }
									})
								} />
						</div>
						:
						null
				}

				{props.premiumSettings.selectedCaseType !== '' &&
						props.premiumSettings.psType !== PS_TYPE_STAGED ? 
					<CustomCheckbox
						centerClassName={'col-sm-9'}
						checked={props.premiumSettings.showAllPremiumSettingsForCombination}
						label={'Show all'}
						name={'showAllPremiumSettingsForCombination'}
						_onChange={(evt) => { props.handleAllPremiumChange(evt.target.name, evt.target.checked) }}
					/> : null}

				{props.premiumSettings.selectedCaseType !== '' &&
					props.premiumSettings.psType === PS_TYPE_STAGED &&
					props.stagedPremiums?.fetchingCurrent == false &&
					props.stagedPremiums?.fetchingAllForCombination == false ?
					<CustomCheckbox
						centerClassName={'col-sm-9'}
						checked={props.stagedPremiums.getAllStagedPremiumsForCombination}
						label={'Show all'}
						name={'getAllStagedPremiumsForCombination'}
							_onChange={(evt) => { props.handleAllStagedPremiumChange(evt.target.name,evt.target.checked) }}
					/> : null}

				{props.premiumSettings?.allPremiumSettingsForCombination?.length > 0 &&
						props.premiumSettings.psType !== PS_TYPE_STAGED ?
					<PremiumSettingsCombinationTable
						push={props.push}
						psType={props.premiumSettings.psType}
						changeNewPremiumStoreSettings={props.changeNewPremiumStoreSettings}
						allPossibleDamages={props.allPossibleDamages}
						data={props.premiumSettings.allPremiumSettingsForCombination}
					/>
					:
					null
				}

				{props.stagedPremiums.allStagedPremiumSetting.length > 0 &&
					props.stagedPremiums.getAllStagedPremiumsForCombination == true &&
					props.premiumSettings.psType === PS_TYPE_STAGED ?
					// PREVIEWS
					<StagedPremiumSettingsCombinationTable
						amountColumnsDisplayDataPerStage={props.amountColumnsDisplayDataPerStage}
						push={props.push}
						allStagedPremiums={props.stagedPremiums.allStagedPremiumSetting}
					/>
					:
					null
				}

				{<div>
					{
						!props.premiumSettings.showAllPremiumSettingsForCombination && (props.premiumSettings.selectedCaseType !== '')
							&& props.stagedPremiums.getAllStagedPremiumsForCombination == false &&
							props.stagedPremiums?.fetchingCurrent == false &&
							props.stagedPremiums?.fetchingAllForCombination == false ?
							<div>
								{
									(
										!props.premiumSettings.fetchingPremiumWithCombination
										&& props.premiumSettings.showTable
									) && (
										<Button
											clickHandler={openCopyModal}
											wrapper="btn-wrapper-forForms"
											btnType="button"
											btnStyle={'btn btn-primary btn-xs sharp yellow'}
											label="Create New Based On Current"
										/>
									)
								}
								{(
									props.premiumSettings.psType === PS_TYPE_STAGED
									&& props.stagedPremiums?.fetchingCurrent == false
									&& props.stagedPremiums?.fetchingAllForCombination == false
									&& props.stagedPremiums.getAllStagedPremiumsForCombination == false
									&& props.stagedPremiums?.stagedPremiumSetting?.id != undefined
								) && (
										<Button
											clickHandler={toggleStagedCopyModal}
											wrapper="btn-wrapper-forForms"
											btnType="button"
											btnStyle={'btn btn-primary btn-xs sharp yellow'}
											label="Create New Based On Current"
										/>
									)}
								<Button wrapper="btn-wrapper-forForms" btnType="button"
									clickHandler={createNewHandle}
									btnStyle={'btn btn-primary btn-xs sharp blue'}
									label="Create New" />

								{!props.premiumSettings.fetchingPremiumWithCombination &&
									props.stagedPremiums?.fetchingCurrent == false &&
									props.stagedPremiums?.fetchingAllForCombination == false &&
									(props.premiumSettings.showTable || (
										props.stagedPremiums?.stagedPremiumSetting?.id != undefined &&
										props.stagedPremiums.getAllStagedPremiumsForCombination == false)) &&
									<Button wrapper="btn-wrapper-forForms" btnType="button"
										clickHandler={props.editHandle}
										btnStyle={'btn btn-primary btn-xs sharp white'}
										label="Edit" />}
							</div>
							:
							null
					}

				</div>
				}
				{props.premiumSettings.psType === PS_TYPE_CUSTOM || props.premiumSettings.psType === PS_TYPE_DEFAULT || props.premiumSettings.psType === PS_TYPE_PERCENTAGE ?
					<NavigationContent>
						{
							props.premiumSettings.fetchingPremiumWithCombination || props.premiumSettings.fetchingAllPremiumsWithCombination ?
								<div className="col-sm-12">
									<CenteredDots />
								</div>
								:
								<div>
									{
										props.premiumSettings.showTable ?
											<PremiumSettingsWizardHOC showTable={true} />
											:
											null
									}
								</div>
						}

					</NavigationContent> : null}

					{	(props.stagedPremiums?.fetchingCurrent == true  || 
						props.stagedPremiums?.fetchingAllForCombination == true)  &&
					<div className="col-sm-12">
						<CenteredDots />
					</div>}
				{props.premiumSettings.psType === PS_TYPE_STAGED && COUNTRY == CANADA_COUNTRY &&
					props.stagedPremiums?.stagedPremiumSetting?.id != undefined &&
					props.premiumSettings?.selectedCaseType !== '' &&
					props.stagedPremiums?.allStagedPremiumSetting?.length == 0 &&
					props.stagedPremiums?.getAllStagedPremiumsForCombination == false &&
					props.stagedPremiums?.fetchingCurrent == false &&
					props.stagedPremiums?.fetchingAllForCombination == false ?
					<NavigationContent>

						<StagedStep4
							amountColumnsDisplayDataPerStage={props.amountColumnsDisplayDataPerStage}
							isApplicationPremium={false}
							stagesSubSettings={props.stagedPremiums.stagedPremiumSetting?.stagedPremiumSubSettings}
							stagedPremiumData={props.stagedPremiums.stagedPremiumSetting}
						/>
					</NavigationContent>

					:null}



			</div>
		</div>
	)
};

export default PremiumSettings
